export default "__VITE_ASSET__cb928521__"